import React from 'react';
import PropTypes from 'prop-types';
import { Input, Form, Dropdown } from 'semantic-ui-react';

const states = [
  { key: '0', value: ' ', text: ' ' },
  { key: '1', value: ' ', text: 'Not Applicable' },
  { key: '2', value: ' ', text: '--- United States ---' },
  { key: 'AL', value: 'AL', text: 'ALABAMA' },
  { key: 'AK', value: 'AK', text: 'ALASKA' },
  { key: 'AS', value: 'AS', text: 'AMERICAN SAMOA' },
  { key: 'AZ', value: 'AZ', text: 'ARIZONA' },
  { key: 'AR', value: 'AR', text: 'ARKANSAS' },
  { key: 'CA', value: 'CA', text: 'CALIFORNIA' },
  { key: 'CO', value: 'CO', text: 'COLORADO' },
  { key: 'CT', value: 'CT', text: 'CONNECTICUT' },
  { key: 'DE', value: 'DE', text: 'DELAWARE' },
  { key: 'DC', value: 'DC', text: 'DISTRICT OF COLUMBIA' },
  { key: 'FM', value: 'FM', text: 'FEDERATED STATES OF MICRONESIA' },
  { key: 'FL', value: 'FL', text: 'FLORIDA' },
  { key: 'GA', value: 'GA', text: 'GEORGIA' },
  { key: 'GU', value: 'GU', text: 'GUAM' },
  { key: 'HI', value: 'HI', text: 'HAWAII' },
  { key: 'ID', value: 'ID', text: 'IDAHO' },
  { key: 'IL', value: 'IL', text: 'ILLINOIS' },
  { key: 'IN', value: 'IN', text: 'INDIANA' },
  { key: 'IA', value: 'IA', text: 'IOWA' },
  { key: 'KS', value: 'KS', text: 'KANSAS' },
  { key: 'KY', value: 'KY', text: 'KENTUCKY' },
  { key: 'LA', value: 'LA', text: 'LOUISIANA' },
  { key: 'ME', value: 'ME', text: 'MAINE' },
  { key: 'MH', value: 'MH', text: 'MARSHALL ISLANDS' },
  { key: 'MD', value: 'MD', text: 'MARYLAND' },
  { key: 'MA', value: 'MA', text: 'MASSACHUSETTS' },
  { key: 'MI', value: 'MI', text: 'MICHIGAN' },
  { key: 'AE', value: 'AE', text: 'MILITARY 090 - 098' },
  { key: 'AA', value: 'AA', text: 'MILITARY 340 - A' },
  { key: 'AP', value: 'AP', text: 'MILITARY 962 - 966' },
  { key: 'MN', value: 'MN', text: 'MINNESOTA' },
  { key: 'MS', value: 'MS', text: 'MISSISSIPPI' },
  { key: 'MO', value: 'MO', text: 'MISSOURI' },
  { key: 'MT', value: 'MT', text: 'MONTANA' },
  { key: 'NE', value: 'NE', text: 'NEBRASKA' },
  { key: 'NV', value: 'NV', text: 'NEVADA' },
  { key: 'NH', value: 'NH', text: 'NEW HAMPSHIRE' },
  { key: 'NJ', value: 'NJ', text: 'NEW JERSEY' },
  { key: 'NM', value: 'NM', text: 'NEW MEXICO' },
  { key: 'NY', value: 'NY', text: 'NEW YORK' },
  { key: 'NC', value: 'NC', text: 'NORTH CAROLINA' },
  { key: 'ND', value: 'ND', text: 'NORTH DAKOTA' },
  { key: 'MP', value: 'MP', text: 'NORTHERN MARIANA ISLANDS' },
  { key: 'OH', value: 'OH', text: 'OHIO' },
  { key: 'OK', value: 'OK', text: 'OKLAHOMA' },
  { key: 'OR', value: 'OR', text: 'OREGON' },
  { key: 'PW', value: 'PW', text: 'PALAU' },
  { key: 'PA', value: 'PA', text: 'PENNSYLVANIA' },
  { key: 'PR', value: 'PR', text: 'PUERTO RICO' },
  { key: 'RI', value: 'RI', text: 'RHODE ISLAND' },
  { key: 'SC', value: 'SC', text: 'SOUTH CAROLINA' },
  { key: 'SD', value: 'SD', text: 'SOUTH DAKOTA' },
  { key: 'TN', value: 'TN', text: 'TENNESSEE' },
  { key: 'TX', value: 'TX', text: 'TEXAS' },
  { key: 'UT', value: 'UT', text: 'UTAH' },
  { key: 'VT', value: 'VT', text: 'VERMONT' },
  { key: 'VI', value: 'VI', text: 'VIRGIN ISLANDS' },
  { key: 'VA', value: 'VA', text: 'VIRGINIA' },
  { key: 'WA', value: 'WA', text: 'WASHINGTON' },
  { key: 'WV', value: 'WV', text: 'WEST VIRGINIA' },
  { key: 'WI', value: 'WI', text: 'WISCONSIN' },
  { key: 'WY', value: 'WY', text: 'WYOMING' },
  { key: '3', value: ' ', text: '----- Canada -----' },
  { key: 'AB', value: 'AB', text: 'ALBERTA' },
  { key: 'BC', value: 'BC', text: 'BRITISH COLUMBIA' },
  { key: 'MB', value: 'MB', text: 'MANITOBA' },
  { key: 'NB', value: 'NB', text: 'NEW BRUNSWICK' },
  { key: 'NL', value: 'NL', text: 'NEWFOUNDLAND and LABRADOR' },
  { key: 'NT', value: 'NT', text: 'NORTHWEST TERRITORIES' },
  { key: 'NS', value: 'NS', text: 'NOVA SCOTIA' },
  { key: 'NU', value: 'NU', text: 'NUNAVUT' },
  { key: 'ON', value: 'ON', text: 'ONTARIO' },
  { key: 'PE', value: 'PE', text: 'PRINCE EDWARD ISLAND' },
  { key: 'QC', value: 'QC', text: 'QUEBEC' },
  { key: 'SK', value: 'SK', text: 'SASKATCHEWAN' },
  { key: 'YT', value: 'YT', text: 'YUKON TERRITORY' },
  { key: '4', value: ' ', text: '----- Mexico -----' },
  { key: 'XA', value: 'XA', text: 'AGUASCALIENTES' },
  { key: 'XC', value: 'XC', text: 'BAJA CALIF SUR' },
  { key: 'XB', value: 'XB', text: 'BAJA CALIFORNIA' },
  { key: 'XD', value: 'XD', text: 'CAMPECHE' },
  { key: 'XE', value: 'XE', text: 'CHIAPAS' },
  { key: 'XF', value: 'XF', text: 'CHIHUAHUA' },
  { key: 'XG', value: 'XG', text: 'COAHUILA' },
  { key: 'XH', value: 'XH', text: 'COLIMA' },
  { key: 'XI', value: 'XI', text: 'DISTRITO FEDERAL' },
  { key: 'XJ', value: 'XJ', text: 'DURANGO' },
  { key: 'XK', value: 'XK', text: 'GUANAJUATO' },
  { key: 'XL', value: 'XL', text: 'GUERRERO' },
  { key: 'XM', value: 'XM', text: 'HIDALGO' },
  { key: 'XN', value: 'XN', text: 'JALISCO' },
  { key: 'XO', value: 'XO', text: 'MEXICO' },
  { key: 'XP', value: 'XP', text: 'MICHOACAN' },
  { key: 'XQ', value: 'XQ', text: 'MORELOS' },
  { key: 'XR', value: 'XR', text: 'NAYARIT' },
  { key: 'XS', value: 'XS', text: 'NUEVO LEON' },
  { key: 'XT', value: 'XT', text: 'OAXACA' },
  { key: 'XU', value: 'XU', text: 'PUEBLA' },
  { key: 'XV', value: 'XV', text: 'QUERETARO' },
  { key: 'XW', value: 'XW', text: 'QUINTANA ROO' },
  { key: 'XX', value: 'XX', text: 'SAN LUIS POTOSI' },
  { key: 'XY', value: 'XY', text: 'SINALOA' },
  { key: 'XZ', value: 'XZ', text: 'SONORA' },
  { key: 'X2', value: 'X2', text: 'TABASCO' },
  { key: 'X3', value: 'X3', text: 'TAMAULIPAS' },
  { key: 'X4', value: 'X4', text: 'TLAXCALA' },
  { key: 'X5', value: 'X5', text: 'VERACRUZ' },
  { key: 'X6', value: 'X6', text: 'YUCATAN' },
  { key: 'X7', value: 'X7', text: 'ZACATECAS' },
];

const StateSelector = props => (
  props.readOnly !== true ?
    <Form.Field
      control={Dropdown}
      label="State/Province"
      placeholder="Please select a state/province"
      value={props.member.state}
      onChange={props.fieldChangeHandler}
      name="state"
      options={states}
      width={props.width ? props.width : '16'}
      required={props.required === true}
      search
      selection
    />
    :
    <Form.Field
      control={Input}
      label="State/Province"
      value={props.member.state}
      name="state"
      width={props.width ? props.width : '16'}
      required={props.required === true}
      readOnly
    />
);

StateSelector.propTypes = {
  fieldChangeHandler: PropTypes.func,
  member: PropTypes.object,
  width: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default StateSelector;



// WEBPACK FOOTER //
// ./src/app/components/States/index.js